// extracted by mini-css-extract-plugin
module.exports = {"background":"LandingPage_background__2-8Xm","video":"LandingPage_video__3ZJEJ","text":"LandingPage_text__2s7-9","link":"LandingPage_link__dDsUo"};